export const ROLES = [
  'INVESTOR',
  'TENANT',
  'SERVICER',
  'SELLER',
  'NOTARY',
  'REPRESENTATIVE',
];
